import { ref } from 'vue';
import { defineStore } from '@pinia';
import { 
  createManyReminders as apiCreateManyReminders,
  closeReminder as apiCloseReminder,
  getActualReminders as apiGetActualReminder,
  getAllReminders as apiGetAllReminder,
  getDetailedReminder as apiDetailedReminder,
  updateReminder as apiUdateReminder
} from "~/api/reminders";
import { INewManyPayload, ICloseReminderPayload, IRemindersListItem, IRemindersDetailed } from "~/types/reminders";
import { ICommonResult, ICommonIDResult } from "~/types/common";
import dayjs from 'dayjs';

export const useRemindersStore = defineStore('reminders', () => {
  // Reactive State
  const actualReminderCount = ref<number>(0);
  const isOverdueReminders = ref<boolean>(false);
  // Actions
  const createManyReminders = async (payload: INewManyPayload): Promise<ICommonIDResult> => {
    try {
      const { data } = await apiCreateManyReminders(payload);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const udateReminder = async (payload: IRemindersDetailed): Promise<ICommonIDResult> => {
    try {
      const { data } = await apiUdateReminder(payload);
      return data;
    } catch (error) {
      throw error;
    }
  };
  
  const closeReminder = async (payload: ICloseReminderPayload): Promise<ICommonResult> => {
    try {
      const { data } = await apiCloseReminder(payload);
      return data;
    } catch (error) {
      throw error;
    }
  };
  
  const getActualReminders = async (): Promise<IRemindersListItem[]> => {
    try {
      const { data } = await apiGetActualReminder();
      const { count = 0, items = [] } = data;
      actualReminderCount.value = count;

      const now = dayjs().toISOString();
      isOverdueReminders.value = items.some((item) => {
        const whenRemind = dayjs(item.whenRemind, 'DD.MM.YYYY HH:mm:ss').toISOString();
        return dayjs(whenRemind).isBefore(now);
      });

      return items
    } catch (error) {
      actualReminderCount.value = 0;
      isOverdueReminders.value = false;
      throw error;
    }
  };

  const getAllReminders = async (): Promise<IRemindersListItem[]> => {
    try {
      const { data } = await apiGetAllReminder();
      return data.items;
    } catch (error) {
      throw error;
    }
  };

  const getDetailedReminder = async (id: number): Promise<any> => {
    try {
      const { data } = await apiDetailedReminder(id);
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    createManyReminders,
    closeReminder,
    getActualReminders,
    getAllReminders,
    actualReminderCount,
    isOverdueReminders,
    getDetailedReminder,
    udateReminder,
  }
});